
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as GzLogo } from "../../icons/gz-icon-lg.svg";
import "./PhysicalOrderBarcodePage.scss";
import Barcode from 'react-barcode';

function PhysicalOrderBarcodePage() {
    const [code, setCode] = useState("");
    const location = new URLSearchParams(useLocation().search);
    const navigate = useNavigate();

    useEffect(() => {
        const code = location.get("code");
        if (code) {
            setCode(code)
        } else {
            navigate("/");
        }
    }, []);

    return (
        <div className="barcode-container">
            <GzLogo />
            <div>
                <div className="title">
                    აჩვენე გზავნილის თანამშრომელს
                </div>

                <div className="barcode">
                    <div className="header">მიღებულია საწყობში</div>
                    <div className="content">
                        <div className="code">
                            <Barcode
                                value={code}
                                format="CODE128"
                                displayValue={true}
                            />
                        </div>
                        <div className="code-description">
                            <div>
                                აღნიშნული ბარ-კოდი წაროადგინეთ გზავნილის
                            </div>
                            <div>
                                ოფისში რათა მიიღოთ
                            </div>
                            <div>
                                მხოლოდ ჩამოსული ამანათები
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PhysicalOrderBarcodePage;